import {useEffect, useState} from 'react';
import {ProductDto} from "@/core/application/dtos/ProductDto";


export const useSearchHistory = () => {
    // const old = localStorage.getItem('history');
    // const [history, setHistory] = useState<IProduct[]>(
    //   old ? JSON.parse(old) : [],
    // );
    const [history, setHistory] = useState<ProductDto[]>([]);

    useEffect(() => {
        // localStorage.setItem('history', JSON.stringify(history));
    }, [history]);

    const addHistory = (term: ProductDto) => {
        setHistory([term, ...history]);
    };

    return {history, addHistory};
};
